<template>
  <!-- 客户支持 -->
  <div class="customerSupportNav" id="customerSupportNav">
    <!-- 头部 -->
    <headerNav activeIndex="customer" @setBanner="setBanner" @getUrl="getUrl"></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div class="pc">
      <div style="padding: 0 72px 72px" id="mainNav">
        <div class="maxWidth mainNav" ref="mainNav" id="mainNav1">
          <!-- 目录 -->
          <div class="mainIndex">
            <ul id="aboutUsIndex" style="position: relative">
              <div
                :style="`position:absolute;top:${top}px;right:55px;width:74px;height:2px;background:#3f6b33;transition: all 0.5s;`"
              ></div>
              <li class="title Regular">联系我们</li>
              <li class="index">
                <span
                  :class="navIndex === 1 ? 'selectBtn' : 'clickBtn2'"
                  @click="goNav(1)"
                  >联系方式</span
                >
              </li>
              <li class="index">
                <span
                  class=""
                  :class="navIndex === 2 ? 'selectBtn' : 'clickBtn2'"
                  @click="goNav(2)"
                  >在线留言</span
                >
              </li>
              <li class="index">
                <span
                  class=""
                  :class="navIndex === 3 ? 'selectBtn' : 'clickBtn2'"
                  @click="addMe"
                  >人才招聘</span
                >
              </li>
            </ul>
          </div>
          <!-- 右侧内容 -->
          <div
            class="mainContent"
            style="border-left: 1px solid #719468; padding-left: 55px"
          >
            <div
              style="
                border-bottom: 1px solid #719468;
                padding: 14px 0;
                line-height: 23px;
                display: flex;
              "
            >
              <div style="font-size: 23px" class="clickBtn1" @click="goHome">
                首页
              </div>
              <div style="font-size: 18px; margin: 0 12px">-</div>
              <div style="font-size: 18px">联系我们</div>
              <div style="font-size: 18px; margin: 0 12px">-</div>
              <div style="font-size: 18px" @click="type = 1">
                {{ navIndex === 1 ? '联系方式' : '在线留言' }}
              </div>
            </div>
            <div
              style="padding: 0px 20px"
              :style="type === 2 ? `margin-top:20px;` : ''"
            >
              <div v-show="navIndex === 1">
                <div style="margin-top: 44px; margin-left: 21px">
                  <div
                    class="Regular"
                    style="font-size: 23px; color: #719468; margin-bottom: 29px"
                  >
                    御方汇 — 黄家圣幸实业集团旗下原料品牌
                  </div>
                  <div
                    style="
                      margin-bottom: 60px;
                      color: #626262;
                      line-height: 18px;
                      font-size: 18px;
                    "
                  >
                    <div style="margin-bottom: 19px" v-for="(item,index) of addressList" :key="index">
                      <img
                        src="@/assets/mobile/address.png"
                        style="width: 20px; margin-right: 10px"
                        alt=""
                      />{{ item }}</div>
                    <div style="margin-bottom: 19px">
                      <img
                        src="@/assets/mobile/phone.png"
                        style="width: 20px; margin-right: 10px"
                        alt=""
                      />电话：{{ phone }}</div>
                    <div>
                      <img
                        src="@/assets/mobile/wz.png"
                        style="width: 20px; margin-right: 10px"
                        alt=""
                      />
                      公司商城：<a :href="path" target="_blank">{{ path }}</a>
                    </div>
                  </div>
                  <div style="margin-bottom: 34px">
                    手机微信扫描官网公众号关注更多信息
                  </div>
                  <div style="margin-bottom: 34px; display: flex">
                    <div style="width: 225px; margin-right: 88px">
                      <img
                        :src="customerQrcode"
                        style="width: 100%; border: 1px dashed #000"
                        alt=""
                      />
                      <div
                        style="
                          color: #000000;
                          font-size: 21px;
                          line-height: 21px;
                          margin-top: 10px;
                          text-align: center;
                        "
                      >
                        官方客服
                      </div>
                    </div>
                    <div style="width: 225px">
                      
                      <img
                        :src="qrcode"
                        style="width: 100%; border: 1px dashed #000"
                        alt=""
                      />
                      <div
                        style="
                          color: #000000;
                          font-size: 21px;
                          line-height: 21px;
                          margin-top: 10px;
                          text-align: center;
                        "
                      >
                        官方公众号
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="navIndex === 2">
                <el-form
                  :model="form"
                  style="margin-top: 58px"
                  :rules="rules"
                  ref="submitForm"
                >
                  <el-row :gutter="40">
                    <el-col :span="12">
                      <el-form-item label="姓名:" prop="name">
                        <el-input
                          placeholder="name"
                          style="width: 100%"
                          v-model="form.name"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="电话:" prop="phone">
                        <el-input
                          placeholder="phone"
                          style="width: 100%"
                          v-model="form.phone"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="邮箱:" prop="email">
                        <el-input
                          placeholder="E-mail"
                          style="width: 100%"
                          v-model="form.email"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="地址:" prop="address">
                        <el-input
                          placeholder="Address"
                          style="width: 100%"
                          v-model="form.address"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="留言:" prop="remark">
                        <el-input
                          type="textarea"
                          placeholder="Please enter what you want to consult..."
                          style="width: 100%"
                          v-model="form.remark"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <div
                  style="
                    text-align: center;
                    margin-top: 20px;
                    display: flex;
                    align-items: center;
                  "
                >
                  <verification
                    :key="verificationkey1"
                    ref="verification"
                    style="width: 300px"
                    :id="0"
                  ></verification>
                  <div style="flex: 1; text-align: right">
                    <el-button
                      type="success"
                      style="width: 158px; margin-right: 16px"
                      @click="submitBtn"
                      >提交</el-button
                    >
                    <el-button
                      type="info"
                      style="width: 158px"
                      @click="resetBtn"
                      >重置</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="maxWidth" style="margin-bottom: 108px" v-if="navIndex === 1">
        <baidu-map
          :center="center"
          :zoom="18"
          style="height: 430px"
          :scroll-wheel-zoom="true"
        >
          <BmMarker
            :position="center"
            title="广州黄家圣幸生物科技有限公司"
            @click="show = !show"
          >
            <bm-info-window
              :show="show"
              @close="show = false"
              @open="show = true"
              style="font-size: 14px"
              >广州黄家圣幸生物科技有限公司<br /><br />地址：广州市番禺区万惠一路48号奥园集团大厦2811室</bm-info-window
            >
          </BmMarker>
        </baidu-map>
      </div>
    </div>
    <div class="mobile">
      <div  style="padding: 0 0.2rem">
        <div style="margin-top: 0.3rem; text-align: center">
        <div
          style="
            font-size: 0.34rem;
            line-height: 1.4;
            color: #ddd;
            font-weight: 400;
            font-family: 'Proxima-Bold', sans-serif;
            text-transform: uppercase;
          "
        >
          contact us
        </div>
        <div
          style="
            font-size: 0.22rem;
            color: #0f3a3c;
            font-weight: 600;
            margin-top: -4px;
          "
        >
          联系我们
        </div>
      </div>
      <div
        class="Regular"
        style="font-size: 0.16rem; color: #719468; margin: 0.2rem 0"
      >
        御方汇 — 黄家圣幸实业集团旗下原料品牌
      </div>
      <div
        style="
          margin-bottom: 0.1rem;
          color: #000;
          line-height: 1.5;
          font-size: 0.14rem;
        "
      >
        <div style="margin-bottom: 0.1rem; display: flex; align-items: center" v-for="(item,index) of addressList" :key="index">
          <img
            src="@/assets/mobile/address.png"
            style="width: 0.16rem; margin-right: 0.05rem"
            alt=""
          />
          <span style="white-space: pre-wrap;">{{ item }}</span>
        </div>
        <div style="margin-bottom: 0.1rem; display: flex; align-items: center">
          <img
            src="@/assets/mobile/phone.png"
            style="width: 0.16rem; margin-right: 0.05rem"
            alt=""
          />
          电话：{{ phone }}
        </div>
        <div style="display: flex; align-items: center">
          <img
            src="@/assets/mobile/wz.png"
            style="width: 0.16rem; margin-right: 0.05rem"
            alt=""
          />
          公司商城：<a target="_blank" :href="path">{{ path }}</a>
        </div>
      </div>
      <div
        class="Regular"
        style="font-size: 0.16rem; color: #000; margin: 0.4rem 0 0.2rem"
      >
        手机微信扫描官网公众号关注更多信息
      </div>
      <div
        style="
          margin-bottom: 34px;
          display: flex;
          justify-content: space-between;
        "
      >
        <div style="width: 45%">
          <img
            :src="customerQrcode"
            style="width: 100%; border: 1px dashed #000"
            alt=""
          />
          <div
            style="
              color: #000000;
              font-size: 0.16rem;
              line-height: 0.18rem;
              margin-top: 0.1rem;
              text-align: center;
            "
          >
            官方客服
          </div>
        </div>
        <div style="width: 45%">
          <img
            :src="qrcode"
            style="width: 100%; border: 1px dashed #000"
            alt=""
          />
          <div
            style="
              color: #000000;
              font-size: 0.16rem;
              line-height: 0.18rem;
              margin-top: 0.1rem;
              text-align: center;
            "
          >
            官方公众号
          </div>
        </div>
      </div>
      <div style="margin-top: 0.3rem; text-align: center" id="onlineMessageM">
        <div
          style="
            font-size: 0.34rem;
            line-height: 1.4;
            color: #ddd;
            font-weight: 400;
            font-family: 'Proxima-Bold', sans-serif;
            text-transform: uppercase;
          "
        >
          Online Message
        </div>
        <div
          style="
            font-size: 0.22rem;
            color: #0f3a3c;
            font-weight: 600;
            margin-top: -4px;
          "
        >
          在线留言
        </div>
        <el-form
          :model="form"
          style="margin-top: 0.2rem"
          :rules="rules"
          ref="submitForm"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="姓名:" prop="name">
                <el-input
                  placeholder="name"
                  style="width: 100%"
                  v-model="form.name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="电话:" prop="phone">
                <el-input
                  placeholder="phone"
                  style="width: 100%"
                  v-model="form.phone"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="邮箱:" prop="email">
                <el-input
                  placeholder="E-mail"
                  style="width: 100%"
                  v-model="form.email"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="地址:" prop="address">
                <el-input
                  placeholder="Address"
                  style="width: 100%"
                  v-model="form.address"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="留言:" prop="remark">
                <el-input
                  type="textarea"
                  placeholder="Please enter what you want to consult..."
                  rows="5"
                  style="width: 100%"
                  v-model="form.remark"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div
          style="
            text-align: center;
          "
        >
          <verification
                :key="verificationkey1"
                ref="verification2"
                style="width: 3.2rem; font-size: 14px; zoom: 1; margin: 0 auto"
                type="mobile"
                :id="1"
                class="switch-Tab"
              ></verification>
          
        </div>
        <div style="text-align:center;margin: 0.2rem 0;">
          <el-button
              type="success"
              style="width: 40%;border-radius:0;padding: 0.12rem 0.2rem;font-size:0.14rem;"
              @click="submitBtn"
              >提交</el-button
            >
            <el-button type="info" style="width: 40%;border-radius:0;padding: 0.12rem 0.2rem;font-size:0.14rem;" @click="resetBtn"
              >重置</el-button
            >
        </div>
      </div>
      </div>
      <div style="margin-bottom: 0.2rem;width:100%;background:#f8f8f8;">
        <div style="padding: 0.3rem 0; text-align: center">
        <div
          style="
            font-size: 0.34rem;
            line-height: 1.4;
            color: #ddd;
            font-weight: 400;
            font-family: 'Proxima-Bold', sans-serif;
            text-transform: uppercase;
            
          "
        >
          <a href="https://m.amap.com/search/mapview/keywords=%E5%B9%BF%E5%B7%9E%E9%BB%84%E5%AE%B6%E5%9C%A3%E5%B9%B8%E7%94%9F%E7%89%A9%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&city=440105&poiid=B0HBYOK761">Website map →</a>
          
        </div>
        
      </div>
      </div>
    </div>
    <!-- 底部 -->
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import headerNav from '@/components/headerNav/index'
import bannerNav from '@/components/banner/index'
import footerNav from '@/components/footerNav/index'
import { getConfByKey, AddOnlineMessage } from '@/api/common'
import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation.vue' //定位
import BmMapType from 'vue-baidu-map/components/controls/MapType.vue' //地图类型
import BmCityList from 'vue-baidu-map/components/controls/CityList.vue' //城市列表
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue' //标记点
import verification from '@/components/verification'
import $ from 'jquery'
export default {
  name: 'customerSupportNav',
  components: {
    headerNav,
    footerNav,
    bannerNav,
    BmGeolocation,
    BmMapType,
    BmCityList,
    verification,
    BmMarker,
  },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: '',
      }, //轮播图
      show: true,
      mobile: false,
      navIndex: 1,
      brandProfileNavShow: false,
      top: 100,
      numShow: false,
      currentPage1: 1,
      type: 1,
      qrcode: '', //微信公众号二维码
      customerQrcode: '', //微信公众号二维码
      center: { lng: 113.35344, lat: 23.01368 },
      verificationkey1: false,
      form: {
        name: '',
        phone: '',
        email: '',
        address: '',
        remark: '',
        type:1,
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入留言', trigger: 'blur' }],
      },
      address: '',
      addressList:[],
      phone: '',
      path: '',
      customerQrcode: '',
      qrcode: '',
      messageBar: {
        success: function (text) {
          var message = document.createElement("div");
          message.id = "messageBar";
          message.innerHTML = `<div style="">
                <i class="el-icon-check" style="font-size:50px;color:#fff;"></i>
             </div>
             <div style="color:#fff;font-size:16px;margin-top:10px;">${text}</div>`;
          document.getElementById("customerSupportNav").append(message);
          setTimeout(() => {
            $("#messageBar").remove();
          }, 2000);
        },
        error: function (text) {
          var message = document.createElement("div");
          message.id = "messageBar";
          message.innerHTML = `<div style="">
                <i class="el-icon-warning-outline" style="font-size:50px;color:#fff;"></i>
             </div>
             <div style="color:#fff;font-size:16px;margin-top:10px;">${text}</div>`;
          document.getElementById("customerSupportNav").append(message);
          setTimeout(() => {
            $("#messageBar").remove();
          }, 2500);
        },
      },
    }
  },
  mounted() {
    this.mobile = this.isMobile()
    this.getInfo()
    if(this.isMobile() === true){
      this.postMessage(
          '御方汇植物化妆品原料【官网】',
          '客户支持',
          window.location.href,
          this.getUrlPrefix(this.getBaseInfo().logo)
        );
    }
      this.resetBtn()
      this.GetRequest()
  },
  methods: {
    getInfo() {
      // 获取手机号
      this.phone = this.getBaseInfo().phone
      // 公司地址
      getConfByKey({ key: 'sys.sum.address' }).then((res) => {
        this.address = res.data.configValue
        this.addressList = this.address.split(";")
      })
      // 公司商城网址
      getConfByKey({ key: 'sys.shop.path' }).then((res) => {
        this.path = res.data.configValue
      })
      // 获取客服
      this.customerQrcode = this.getUrlPrefix(this.getBaseInfo().customerQrcode)
      // 获取公众号
      this.qrcode = this.getUrlPrefix(this.getBaseInfo().qrcode)
    },
    setBanner(url,mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      }
    },
    goNav(name) {
      var a = document.getElementById('mainNav').offsetTop
      $('body,html').animate({ scrollTop: a - 120 }, 200)
      if (this.navIndex === name) {
        return
      }
      this.navIndex = name
      this.type = 1
      if (name === 1) {
        this.top = 96
      } else {
        this.top = 153
      }
      this.resetBtn()
    },
    goNav1(name) {
      // console.log($(`#${name}`))
      // $(`#${name}`).animate({ scrollTop: 0 }, 1000);
      // this.$refs[name].scrollIntoView({
      //   behavior: "smooth",
      //   block: "end",
      // });
      var top = 560
      if(this.isMobile() === true){
        name = name+"M"
        top = 0
      }
      
      var a = document.getElementById(name).offsetTop
      $('body,html').animate({ scrollTop: a + top }, 200)
    },
    getUrl(val){
      var name = val.replace('#', '')
      this.$nextTick(() => {
        this.goNav1(name)
      })
    },
    submitBtn() {
      this.$refs['submitForm'].validate((valid) => {
        if (valid) {
          if(this.isMobile() === false){
            if (this.$refs.verification.confirmSuccess == false) {
              this.$notify.error(`请完成拖动滑块验证`)
              return
            }
          }else{
            if (this.$refs.verification2.confirmSuccess == false) {
              this.messageBar.error(`请完成拖动滑块验证`)
              return
            }
          }
          if (this.form.email === '') {
            this.form.email = null
          }
          AddOnlineMessage(this.form)
            .then((res) => {
              if(this.isMobile() === false){
                this.$message.success('提交成功')
              }else{
                this.messageBar.success('提交成功')
              }
              this.resetBtn()
            })
            .catch((res) => {
              if(this.isMobile() === false){
                this.$message.error(res)
              }else{
                this.messageBar.error(res)
              }
            })
        }
      })
    },
    resetBtn() {
      console.log('重置')
      this.verificationkey1 = !this.verificationkey1
      this.form = {
        name: '',
        phone: '',
        email: '',
        address: '',
        remark: '',
        type:1,
      }
    },
    goHome() {
      this.$router.push({ name: 'home' })
    },
    addMe(){
      this.$router.push({ name: 'joinUs' })
    },
    GetRequest() {
      var str = location.href;
      var num = str.indexOf("#");
      str = str.substr(num);
      console.log('num:',str)
      if(str === "#nav2"){
        this.goNav(2)
      }
    },
  },
  
  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
}
</script>

<style lang="scss">
.customerSupportNav {
  .maxWidth {
    width: 1229px;
    margin: 0 auto;
  }
  .mainIndex {
    width: 217px;
  }
  .mainContent {
    flex: 1;
  }
  .mainNav {
    position: relative;
    margin-top: 98px;
    display: flex;
  }
  .brandProfileNav {
    position: relative;
  }
  .mainIndex {
    text-align: right;
    ul {
      padding: 8px 55px 8px 0;
    }
    .title {
      color: #1b1b1b;
      font-size: 27px;
      line-height: 27px;
      margin-bottom: 32px;
    }
    .index {
      color: #707070;
      font-size: 18px;
      line-height: 27px;
      margin-bottom: 30px;
    }
    .index:last-child {
      margin-bottom: 0;
    }
  }
  .clickBtn2 {
    cursor: pointer;
  }
  .selectBtn {
    color: #3f6b33;
    cursor: pointer;
    position: relative;
  }
  .selectBtn1::after {
    content: '';
    width: 100%;
    height: 2px;
    background: #3f6b33;
    position: absolute;
    bottom: -10px;
    left: 0;
    transition: all 0.5s ease 0s;
  }
  .mobile{
    .el-form-item__label{
      line-height:26px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/customerSupport/index.vue